import { Button, Icon } from "@material-ui/core";
import { ModalFullScreen } from "../ModalFullScreen";
import "./style.scss";

export const ModalIframeCourse = ({ lesson, handleModalIframe }) => {
	const dynamicLessonUrl = lesson.link_video_aula_dinamica;

	return (
		<ModalFullScreen container={false}>
			<div className="modal-iframe-container">
				<Button
					onClick={() => handleModalIframe(false)}
					className="modal-iframe-close-button"
				>
					<Icon className="modal-iframe-close-icon">close</Icon>
				</Button>
				<iframe
					className="modal-iframe-content"
					title="Dynamic Lesson"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
					src={dynamicLessonUrl}
				/>
			</div>
		</ModalFullScreen>
	);
};
